<template>
  <div class="document-preview panel mt-3 pl-2 pr-2" v-html="previewHTML" />
</template>

<script>
import { schemaMixin } from '@witkac/jschema';
import { mapState } from 'vuex';

import { PublicSettings } from '@/enums/publicSettings.enum';
import { previewMixin } from '@/mixins/preview';
import { renderMixin } from '@/mixins/render';

// @vuese
// Komponent generujący odpowiedni wzór formularza
export default {
  mixins: [previewMixin, renderMixin],
  computed: {
    ...mapState({
      viewId: state => state.setting.settings[PublicSettings.DOCUMENT_VIEW_ID]?.value
    }),
    previewUrl() {
      return this.getPreviewURL(this.$route.params.documentId, this.viewId);
    }
  },
  beforeMount() {
    this.fetchPreview(this.previewUrl).then(html => {
      const styleStart = html.indexOf('<style>');
      const style = html.slice(styleStart);
      this.previewHTML = html.slice(0, styleStart) + '\n' + this.prepareStyle(style);
    });
  },
  methods: {
    prepareStyle(style) {
      return style.replace(/[^}\n]+{/g, match => {
        const [selectors, body] = match.split('{');
        const fixedSelectors = selectors
          .split(',')
          .map(selector => '.document-preview ' + selector)
          .join(',');
        return [fixedSelectors, body].join('{');
      });
    }
  }
};
</script>

<style>
.document-preview {
  font-size: initial;
  color: initial;
  line-height: initial;
  font-weight: initial;
}
</style>
